import { helper } from '@ember/component/helper';

/**
 * Confronta due valori convertendoli in stringa
 * Gestisce casi speciali con booleani false
 */
var isEqualLarge = helper(function isEqualLarge([first, second]) {
  if (first === undefined || second === undefined) return false;

  // Gestione speciale per false booleano
  if (first === false || second === false) {
    return first === false && second === false;
  }
  return String(first) === String(second);
});

export { isEqualLarge as default };
//# sourceMappingURL=is-equal-large.js.map
